import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import cView from './cView';
import i10v1a from './i10v1a';

export default class i15v extends cView { // 設備予約　管理用用画面

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stgs = { //  子で上書き
};

$cd_stss = { // 親を上書き
  sdld_i15rListsss: {i15r:[]},
  sdld_i15rDtlsss: {i15r:[]},
};

static op_loadList = (pd={
  elm: null,
}) => 
  (pd.elm == 'i15r') ?
    super.op_loadList({
      dd_cldDefss: {
        i150: {
          elm: 'i150',
          o_cnd: _dd_datss => {
            let _cnd = cf.c('i150', `i150br1k = ${_dd_datss.i15r.d_flds._key}`, false, false);
//ff.l('41: {}'.f(_cnd));
            return _cnd;
          },
        },
      },
      ...pd,
    })
  : super.op_loadList(pd);

static op_loadDtl = (pd={
  elm: null,
}) => 
  (pd.elm == 'i15r') ?
    super.op_loadDtl({
      dd_cldDefss: {
        i150: {
          elm: 'i150',
          o_cnd: _dd_datss => {
            let _cnd = cf.c('i150', `i150br1k = ${_dd_datss.i15r.d_flds._key}`, false, false);
//ff.l('60: {}'.f(_cnd));
            return _cnd;
          },
        },
      },
      ...pd,
    })
  : super.op_loadDtl(pd);

$clp_loadLists = () => [ // 親を上書き
  i15v.op_loadList({
    elm: 'i15r',
    ld_sortss: [
      { fld: 'i15rc11s', dtn: 'asc', mode: 'nmb' }
    ],
  }),
  i10v1a.op_loadSlcList({
    elm: 'i10r',
  }),
];

$clp_loadDtls = () => [
  i15v.op_loadDtl({
    elm: 'i15r',
  }),
  i15v.op_loadVsnList({ // 時間帯
    elm: 'i15r',
  }),
];

$clp_upds = () => [
  cr.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_i15rDtlsss',
    b_vsn: true,
    dd_elmDefss: {
      i15r: {
        b_setPageKey: true,
        od_insDats: _dd_datss => {
          let _d = {
            i15rc11s: _dd_datss.i15r.d_flds.i15rc11s ?? '',
            i15rc31s: _dd_datss.i15r.d_flds.i15rc31s ?? '',
            i15rt11i: _dd_datss.i15r.d_flds.i15rt11i ?? -1,
            i15rt32i: _dd_datss.i15r.d_flds.i15rt32i ?? -1,
            i15rt33i: _dd_datss.i15r.d_flds.i15rt33i ?? -1,
            i15rt41i: _dd_datss.i15r.d_flds.i15rt41i ?? -1,
            i15ri11i: _dd_datss.i15r.d_flds.i15ri11i ?? -1,
            i15ri21i: _dd_datss.i15r.d_flds.i15ri21i ?? -1,
            i15ri31i: _dd_datss.i15r.d_flds.i15ri31i ?? -1,
            i15ri12i: _dd_datss.i15r.d_flds.i15ri12i ?? 1,
            i15ri22i: _dd_datss.i15r.d_flds.i15ri22i ?? 1,
            i15ri32i: _dd_datss.i15r.d_flds.i15ri32i ?? 1,
          };
          return _d;
        },
        dd_cldDefss: {
          i150: {
            b_setPageKey: false,
            od_insDats: _dd_datss => {
              let _d = {
                i150br1k: _dd_datss.i15r.d_flds._key ?? -1,
                i150b41f: _dd_datss.i150.d_flds.i150b41f ?? -1,
              };
//ff.l('113: {}'.f(_d));
              return _d;
            },
          },

        },
      },
    },
  }),
];

render() {
  return (
    ce.c(ce.RootDtl, {
      key: -1,
      d_hdrs: {
        pfx: 
          (global.t?.state.sgc_pnlMode == 'list') ?
            '団体種別一覧・登録'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
            '団体種別詳細・変更'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'edit') ?
            '団体種別詳細・変更'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?
            '団体種別詳細・変更'
          : null,
        d_subs: 
          ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
            {
              iconName: 'users',
              pfx: 'ユーザ切替',
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.t?.state.sgc_pageRole,
                  sgc_pageName: 'c00v2a',
                  sgc_pageMode: 'show',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
            }
          : null,
      },
      d_bdys: {
        l_clds: [

          ce.c(ce.Pnl, {
            key: -1,
            mode: 'list',
            b_vsb: (global.t?.state.sgc_pnlMode == 'list') ? true : false,
            d_bdys: {
              d_msgBfrs: {
                pfx: `【団体種別詳細の確認・変更】･･･IDを押すと詳細画面に移動し、変更、削除もその画面で行えます。`,
                n_mgnTop: ic.s(1),
                d_stlCtas: {
                  minWidth: ic.gn_bdyW,
                },
              },
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [

                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_i15rListsss',
                    dd_elmDefss: {
                      i15r: {
                        elm: 'i15r',
                        b_row: true,
                        b_rootHdr: true,
                        b_ttl: false,
                        d_insFlds: cf.e('i15r').d_insFlds,
                        d_btns: {
                          d_dlts: {
                            b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                          },
                        },
                        d_stlHdrRows: {
                          height: ic.s(1.8),
                        },
                        d_stlBdyRows: {
                          height: ic.s(2.2),
                          marginTop: ic.s(0.2)
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('i15rc11s', {
                            b_key: true,
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(6) },
                          }),
                          cf.f('i15rc31s', {
                            d_hdrs: { n_w: ic.s(16)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                        ]),

                      },
                    },
                  }),

                ]),
              ],
            },
            d_btms: {
              l_clds: [
                ce.c(ce.Box, {
                  key: -2,
                  stlCta: {
                    minHeight: ic.s(2 * 2),
                    width: ic.gn_minBdyW,
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    marginTop: ic.s(0.5), // 20211202
                    marginBottom: ic.s(0.5), // 20211202
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }
                }, [
                  ce.c(ce.Btn, {
                    key: -20,
                    pfx: '前の画面に戻る',
                    stlBtn: {
                      width: ic.s(8),
                      backgroundColor: ic.g_ccdHN,
                      borderColor: ic.g_ccdHN,
                    },
                    o_onPrs: () => {
                      let _d_pageInfs = {
                        sgc_pageRole: global.t?.state.sgc_pageRole,
                        sgc_pageName: 'iStg1',
                        sgc_pageMode: 'show',
                      }; 
                      cf.myRN_move_fwd(_d_pageInfs);
                    },
                  }),
                  ce.c(ce.Btn, {
                    key: -10,
                    pfx: '団体種別の新規登録',
                    b_rvs: false,
                    stlBtn: {
                      width: ic.s(12),
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        elm: 'i15r',
                        state: 'sdld_i15rDtlsss',
                        d_insFlds: cf.e('i15r').d_insFlds, 
                        mode: 'sttNew',
                        b_clr: true, // 現行要素の初期化に必要
                      })
                    },
                  }),
                ])
              ],
            },
/*
            d_btms: {
              d_news: {
                elm: 'i16r',
                state: 'sdld_i16rDtlsss',
                d_insFlds: cf.e('i16r').d_insFlds,
              },
            }
*/
          }),

          ce.c(ce.Pnl, {
            key: -2,
            mode: 'dtl',
            b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
            d_hdrs: {
              d_htys: {
                elm: 'i15r',
                ld_iss: global.t?.state.sdld_i15rVsnListsss?.i15r,
                op_loadDtl: i15v.op_loadDtl,
              },
            },
            d_bdys: {
              d_stlCtas: {
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
              },
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [

                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_i15rDtlsss',
                    dd_elmDefss: {
                      i15r: {
                        elm: 'i15r',
                        b_ttl: true,
                        d_insFlds: cf.e('i15r').d_insFlds,
                        d_btns: {
                          d_dlts: {
                            b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                          },
                        },
                        d_cmns: {
                          n_cnt: 1,
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('i15rc11s', {
                            d_hdrs: { n_w: ic.s(12)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                          cf.f('i15rc31s', {
                            d_hdrs: { n_w: ic.s(12)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                          cf.f('i15rt11i', {
                            d_hdrs: { n_w: ic.s(12)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                          cf.f('i15rt33i', {
                            d_hdrs: { n_w: ic.s(12)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                          cf.f('i15rt32i', {
                            d_hdrs: { n_w: ic.s(12)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                          cf.f('i15rt41i', {
                            d_hdrs: { n_w: ic.s(12)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                          cf.f('i15ri11i', {
                            d_hdrs: { n_w: ic.s(12)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                          cf.f('i15ri21i', {
                            d_hdrs: { n_w: ic.s(12)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                          cf.f('i15ri31i', {
                            d_hdrs: { n_w: ic.s(12)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),

                          cf.f('i15ri12i', {
                            d_hdrs: { n_w: ic.s(12)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                          cf.f('i15ri22i', {
                            d_hdrs: { n_w: ic.s(12)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                          cf.f('i15ri32i', {
                            d_hdrs: { n_w: ic.s(12)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),

                        ]),

                      },
                    },
                  }),
                ]),

                (
                  bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) || 
                  ff.myCM_getLen(global.t?.state.sdld_i15rDtlsss?.i15r[0]?.dld_cldDatsss?.i150) > 0
                ) ?
                  ce.c(ce.Box, {
                    key: -20,
                    n_mgnTop: ic.s(1),
                  }, [
                    ce.c(cr.InpTree, {
                      key: -1,
                      state: 'sdld_i15rDtlsss',
                      dd_elmDefss: {
                        i15r: {
                          elm: 'i15r',
                          dd_cldDefss: {
                            i150: {
                              elm: 'i150',
                              b_row: true,
                              b_subHdr: true,
                              b_ttl: false,
                              d_btns: {
                                d_dlts: {
                                  b_vsb: bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
                                },
                                d_btrs: {
                                  pfx: '室・設備を追加',
                                  b_vsb: bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
                                },
                              },
                              d_insFlds: cf.e('i150').d_insFlds,
                              b_lyr: false,
                              dd_fldDefss: cf.myRN_getFldDefs([
                                cf.f('i150b41f', {
                                  pfx: '予約不可の室・設備',
                                  ld_iss: global.t?.state.sdld_i10rSlcListsss?.i10r,
                                  d_hdrs: { n_w: ic.s(15)  },
                                  d_bdys: { n_w: ic.s(15) },
                                }),
                              ]),
                              d_stlSubBdyCtas: {
                                borderWidth: 0,
                                borderTopWidth: ic.gn_bdrWNrw,
                                borderBottomWidth: ic.gn_bdrWNrw,
                                borderColor: ic.o_getCcd('d'),
                              },
                            },
                          },
                        },
                      },
                    }),
                  ])
                : null,

              ],
            },
            d_btms: {
            },
          }),

        ],
      }
    })
  );
}

}
